var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('form-sindicato')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h2',[_vm._v("Novo Sindicato")])])
}]

export { render, staticRenderFns }